import gql from 'graphql-tag';

import type { Brief } from 'src/data/brief';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryBriefArgs } from 'src/types/backend';

import { BRIEF_FRAGMENT } from './schema';

const QUERY = gql`
  query QueryBrief($id: ID!) {
    brief(id: $id) {
      ...Brief
    }
  }
  ${BRIEF_FRAGMENT}
`;

type Variables = BackendQueryBriefArgs;
type Result = Brief;

export const queryBrief = async (variables: Variables): Promise<Result | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
